// Set VITE_AI_FN_SUFFIX=-test when running locally to talk to the test copies
// of the AI functions (chat-test, generate-quiz-test) instead of the live ones.
export const AI_FN_SUFFIX: string = (import.meta.env.VITE_AI_FN_SUFFIX as string | undefined) ?? '';
